import { ApiBase } from "../internal";

export class CombinedPlanApi extends ApiBase {
  async loadCombinedPlan(combinedPlanId) {
    try {
      const response = await this.httpClient.get(
        "/combinedplan/getcombinedplan/" + combinedPlanId,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language":
              sessionStorage.getItem("language") === "en"
                ? "en-US"
                : sessionStorage.getItem("language"),
          },
        },
      );
      return response;
    } catch (error) {
      console.error("CombinedPlan API. Load CombinedPlan ERROR: ", error);
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }

  async saveParentLearningAreaText(planId, areaIndex, text) {
    try {
      const response = await this.httpClient.post(
        "/combinedplan/saveparentlearningareatext",
        { PlanId: planId, AreaIndex: areaIndex, Text: text },
        { headers: { "Content-Type": "application/json" } },
      );
      return response;
    } catch (error) {
      console.error(
        "CombinedPlan API. Save parent learning area text ERROR: ",
        error,
      );
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }

  async saveChildPerspectiveText(planId, areaIndex, text) {
    try {
      const response = await this.httpClient.post(
        "/combinedplan/savechildperspectivetext",
        { PlanId: planId, AreaIndex: areaIndex, Text: text },
        { headers: { "Content-Type": "application/json" } },
      );
      return response;
    } catch (error) {
      console.error(
        "CombinedPlan API. Save child perspective text ERROR: ",
        error,
      );
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }

  async saveGuardianSpringText(
    planId,
    text,
    subSectionLevel1,
    subSectionLevel2,
  ) {
    try {
      const response = await this.httpClient.post(
        "/combinedplan/saveguardianspringtext",
        {
          PlanId: planId,
          Text: text,
          SubSectionLevel1: subSectionLevel1,
          SubSectionLevel2: subSectionLevel2,
        },
        { headers: { "Content-Type": "application/json" } },
      );
      return response;
    } catch (error) {
      console.error(
        "CombinedPlan API. Save guardian spring text ERROR: ",
        error,
      );
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }

  async saveCustomQuestionText(planId, questionId, field, text) {
    try {
      const response = await this.httpClient.post(
        "/combinedplan/savecustomquestiontext",
        { PlanId: planId, QuestionId: questionId, Field: field, Text: text },
        { headers: { "Content-Type": "application/json" } },
      );
      return response;
    } catch (error) {
      console.error(
        "CombinedPlan API. Save custom question text ERROR: ",
        error,
      );
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }

  async loadSelfAssessment(combinedPlanId) {
    try {
      const response = await this.httpClient.get(
        "/combinedplan/getselfassessment/" + combinedPlanId,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language":
              sessionStorage.getItem("language") === "en"
                ? "en-US"
                : sessionStorage.getItem("language"),
          },
        },
      );
      return response;
    } catch (error) {
      console.error("CombinedPlan API. Load self-assessment ERROR: ", error);
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }

  async saveSelfAssessment(planId, season, items) {
    try {
      const response = await this.httpClient.post(
        "/combinedplan/saveselfassessment",
        { PlanId: planId, Season: season, Items: items },
        { headers: { "Content-Type": "application/json" } },
      );
      return response;
    } catch (error) {
      console.error("CombinedPlan API. Save self-assessment ERROR: ", error);
      return {
        status:
          error.response === undefined || error.response.status === undefined
            ? 502
            : error.response.status,
      };
    }
  }
}
